import {
	ToothPathologyToothWear,
	ToothSurface,
} from '../../../../../graphql/graphql';
import { useCallback, useMemo } from 'react';
import { SurfaceOperation } from '../../../Enums/SurfaceOperation.enum';
import { handleSurfacesOperation } from '../../../Helpers/surfaces/toothSurfaces.helper';
import { ToothWearSurfacesKey } from '../../../Helpers/toothWear/toothWearSurfaces.config';

interface Props {
	toothWear?: ToothPathologyToothWear;
	setToothWear: (toothWear: ToothPathologyToothWear) => void;
}

export default function useToothPathologyToothWearSurfaces(
	key: ToothWearSurfacesKey,
	{ toothWear, setToothWear }: Props,
) {
	const setSurfaces = useCallback(
		(surfaces: ToothSurface[], operation: SurfaceOperation) => {
			setToothWear({
				...toothWear,
				[key]: {
					surfaces: handleSurfacesOperation(
						toothWear?.[key]?.surfaces ?? [],
						surfaces,
						operation,
					),
				},
			});
		},
		[key, toothWear, setToothWear],
	);

	return useMemo(
		() => ({
			[key]: {
				surfaces: toothWear?.[key]?.surfaces ?? [],
				setSurfaces,
			},
		}),
		[key, toothWear, setSurfaces],
	);
}
